import { render, staticRenderFns } from "./AddEventFaculty.vue?vue&type=template&id=1a7aeb45&scoped=true"
import script from "./AddEventFaculty.vue?vue&type=script&lang=js"
export * from "./AddEventFaculty.vue?vue&type=script&lang=js"
import style0 from "./AddEventFaculty.vue?vue&type=style&index=0&id=1a7aeb45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7aeb45",
  null
  
)

export default component.exports